import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import BOSS_mainlogo from '../../../../assets/icons/BOSS_mainlogo.svg';
import { useNavigate } from 'react-router-dom';
import './WhatsappForgotPassword.scss';
import GetRequest from '../../../../service/GetRequest';
import PhoneInput from 'react-phone-input-2';
import { Message } from 'primereact/message';

const ForgotPassword = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  const navigate = useNavigate();

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const handlePhoneSubmit = async (e) => {
    e.preventDefault();

    if (!phoneNumber) {
      setError('Please enter a valid phone number');
      return;
    }

    try {
      const formattedNumber = `+${phoneNumber}`;
      const response = await GetRequest(`auth/forgot/password/whatsapp?phoneNumber=${formattedNumber}`);

      if (response.status === 204) {
        setMessage('A reset password link has been sent to your phone number.');
        setMessageType('success');
        setShowMessage(true);
        setTimeout(() => {
          setShowMessage(false);
          navigate(`/whatsapp-forgot-password?phoneNumber=${phoneNumber}`);
        }, 2000);
      } else if (response.status === 403) {
        setError('User not found.');
        setMessageType('error');
        setShowMessage(true);
        setTimeout(() => setShowMessage(false), 2000);
      }
    } catch (err) {
      setError(err.message || 'An error occurred');
    }
  };

  return (
    <Container className="ForgotPasswordContainer">
      <Row>
        <Col xs={12} className="ForgotPasswordHeader">
          <img src={BOSS_mainlogo} alt="BOSS Logo" />
          <h2>Forgot Password</h2>
        </Col>
      </Row>
      <Row className="justify-content-md-center">
        <Col xs={12} md={6}>
          <div className="forgot-password-form">
            <Form.Label style={{fontSize:"16px", fontWeight:"bold"}}>Whatsapp Number</Form.Label>
            <br /><br />
            <Form onSubmit={handlePhoneSubmit}>
              <PhoneInput
                country={"gb"}
                enableSearch={true}
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
              />
              {error && <div className="error">{error}</div>}
              <Button variant="primary" type="submit" className="send-otp-button">
                Reset Password
              </Button>
            </Form>
          </div>
        </Col>
      </Row>
      {showMessage && (
        <Message severity={messageType} text={message} style={{marginTop: "10px",marginBottom:"10px"}} />
      )}
    </Container>
  );
};

export default ForgotPassword;
